import classes from './login.module.css';

const LoginFooter = () => (
  <div className={classes.loginFooter}>
    <a
      className={classes.loginFooterElement}
      target="_blank"
      href="https://atom-ai.com/terms-of-service/"
    >
      Terms of Service
    </a>
    <a
      className={classes.loginFooterElement}
      target="_blank"
      href="https://atom-ai.com/privacy-policy/"
    >
      Privacy Policy
    </a>
    <a
      className={classes.loginFooterElement}
      target="_blank"
      href="https://atom-ai.com/"
    >
      Atom Website
    </a>
  </div>
);

export default LoginFooter;
